module.exports = __webpack_public_path__ + "static/media/addon-dark.92c857bc.svg";